import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  FeedLoadAction,
  FeedLoadNewerThreadsAction,
  FeedLoadOlderThreadsAction,
} from '../../domains/feedLoad/actions.types';
import type {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/loadActions.types';
import type {
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
} from '../../domains/publishers/actions.types';
import type {
  SecondLevelRepliesLoadLastFulfilledAction,
  SecondLevelRepliesLoadNextFulfilledAction,
  SecondLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/secondLevelReplies/actions.types';
import type {
  TopLevelRepliesLoadInitialFulfilledAction,
  TopLevelRepliesLoadLastFulfilledAction,
  TopLevelRepliesLoadNextFulfilledAction,
  TopLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/topLevelReplies/actions.types';

import type { MessageSenderBadges } from './types';

export type MessageSenderBadgesAction =
  | FeedLoadAction
  | FeedLoadOlderThreadsAction
  | FeedLoadNewerThreadsAction
  | PublishGroupMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | TopLevelRepliesLoadInitialFulfilledAction
  | TopLevelRepliesLoadPreviousFulfilledAction
  | TopLevelRepliesLoadNextFulfilledAction
  | TopLevelRepliesLoadLastFulfilledAction
  | SecondLevelRepliesLoadPreviousFulfilledAction
  | SecondLevelRepliesLoadNextFulfilledAction
  | SecondLevelRepliesLoadLastFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadLoadFulfilledAction;

const initialState: MessageSenderBadges = {};

const reducer: Reducer<MessageSenderBadges, MessageSenderBadgesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'SECOND_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'SECOND_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'SECOND_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'TOP_LEVEL_REPLIES.LOAD_INITIAL_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'TOP_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'TOP_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'TOP_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
      return addAllToRecord(state, action.payload.entities.messageSenderBadges);
    default:
      return state;
  }
};

export default reducer;
